export const orangeDarkBg = {
	root: {
		primary: {
			background: '{rdusOrangeDark.400}',
			borderColor: '{rdusOrangeDark.400}',
			hoverBackground: '{rdusOrangeDark.500}',
			hoverBorderColor: '{rdusOrangeDark.500}',
		},
	},
}

export const orangeLightBg = {
	root: {
		primary: {
			background: '{rdusOrangeLight.500}',
			borderColor: '{rdusOrangeLight.500}',
			hoverBackground: '{rdusOrangeLight.600}',
			hoverBorderColor: '{rdusOrangeLight.600}',
		},
	},
}

export const whiteBtn = {
	root: {
		primary: {
			background: '{surface.100}',
			borderColor: '{surface.100}',
			hoverBackground: '{surface.200}',
			hoverBorderColor: '{surface.200}',
			color: '{surface.900}',
			hoverColor: '{surface.800}',
			activeBackground: '{surface.800}'
		},
	},
}

export const whiteToggleBtn = {
	togglebutton: {
		root: {
			background: '{surface.50}',
			borderColor: '{surface.50}',
			hoverBackground: '{surface.100}',
			hoverBorderColor: '{surface.100}',
			color: '{surface.800}',
			hoverColor: '{surface.800}',
		},
	},
}
